var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('div',{staticClass:"h-100"},[(_vm.name === 'VIP')?_c('VIPHome'):_vm._e(),(_vm.name === 'FAN')?_c('FANHome'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }